var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import styled from 'styled-components';
import useFocus from '../../../hooks/useFocus';
import getThemeBreakpoints from '../../../utils/getThemeBreakpoints';
import getThemeTypography, { Typographies } from '../../../utils/getThemeTypography';
import FieldBox from '../FieldBox';
var TextArea = function (_a) {
    var name = _a.name, type = _a.type, disabled = _a.disabled, placeholder = _a.placeholder, className = _a.className, value = _a.value, _b = _a.onChange, onChange = _b === void 0 ? function (_) { } : _b, isFocused = _a.isFocused, fieldBoxProps = _a.fieldBoxProps, inputProps = __rest(_a, ["name", "type", "disabled", "placeholder", "className", "value", "onChange", "isFocused", "fieldBoxProps"]);
    var textAreaRef = useRef();
    useFocus({ isFocused: isFocused, ref: textAreaRef });
    var handleChange = function (e) {
        var newValue = e.target.value;
        if (fieldBoxProps === null || fieldBoxProps === void 0 ? void 0 : fieldBoxProps.maxLength) {
            var maxLength = fieldBoxProps.maxLength;
            if ((newValue === null || newValue === void 0 ? void 0 : newValue.length) > maxLength) {
                return;
            }
        }
        onChange(newValue);
    };
    return (_jsx(StyledFieldBox, __assign({ name: name, className: className, value: value || '', disabled: disabled, placeholder: placeholder, onClear: function () { return onChange(''); } }, fieldBoxProps, { children: _jsx(StyledTextArea, __assign({ name: name, value: value || '', onChange: handleChange, placeholder: placeholder, disabled: disabled, "data-testid": name + "-input", ref: textAreaRef }, inputProps), void 0) }), void 0));
};
export default TextArea;
var TextAreaTypography = styled.textarea(getThemeTypography(Typographies.BODY1));
var StyledTextArea = styled(TextAreaTypography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  border: none;\n  resize: none;\n  height: 100%;\n  outline: none;\n  padding: 7px 0 0 0;\n  margin: 0;\n  font-family: inherit;\n  flex: 1;\n  color: inherit;\n  background: inherit;\n"], ["\n  width: 100%;\n  border: none;\n  resize: none;\n  height: 100%;\n  outline: none;\n  padding: 7px 0 0 0;\n  margin: 0;\n  font-family: inherit;\n  flex: 1;\n  color: inherit;\n  background: inherit;\n"])));
var StyledFieldBox = styled(FieldBox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .", "-wrapper {\n    ", "\n  }\n\n  .", "-label {\n    transform: translateY(-168%);\n  }\n\n  .", "-label.active {\n    transform: translateY(-290%) translateX(5px);\n  }\n\n  .", "-addons-wrapper {\n    margin-top: auto;\n  }\n"], ["\n  .", "-wrapper {\n    ", "\n  }\n\n  .", "-label {\n    transform: translateY(-168%);\n  }\n\n  .", "-label.active {\n    transform: translateY(-290%) translateX(5px);\n  }\n\n  .", "-addons-wrapper {\n    margin-top: auto;\n  }\n"])), function (_a) {
    var name = _a.name;
    return name;
}, getThemeBreakpoints('textarea'), function (_a) {
    var name = _a.name;
    return name;
}, function (_a) {
    var name = _a.name;
    return name;
}, function (_a) {
    var name = _a.name;
    return name;
});
var templateObject_1, templateObject_2;
